import React from 'react';
import Switch from 'react-switch';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useStyles } from 'providers/ThemeProvider';
import useTheme from 'hooks/useTheme';

const propTypes = {
  onChange: PropTypes.func,
  id: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
};

const SwitchCommon = ({
  className,
  onChange = () => {},
  id = '',
  checked = false,
  disabled = false,
  style,
}) => {
  //! State
  const { colorsSystem } = useStyles();
  const { isDarkTheme } = useTheme();

  //! Function

  //! Render
  return (
    <Switch
      onColor={isDarkTheme ? '#abbdff' : '#69b1ff'}
      onHandleColor={colorsSystem.brandPrimary}
      handleDiameter={22}
      uncheckedIcon={false}
      checkedIcon={false}
      boxShadow='0px 1px 5px rgba(0, 0, 0, 0.6)'
      activeBoxShadow='0px 0px 1px 10px rgba(0, 0, 0, 0.2)'
      height={20}
      width={40}
      checked={checked}
      onChange={onChange}
      className={classNames(className, 'react-switch')}
      disabled={disabled}
      id={id}
    />
  );
};

SwitchCommon.propTypes = propTypes;
export default React.memo(SwitchCommon);
